module.exports = __webpack_public_path__ + "media/images/amazon_logo-a2e7a451ad53a7e3b29f9ee9acda822d.png";